import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { Button } from '@dojo/widgets/button';
import Icon from '@holmescorp/base-widgets/icon';
import { Card } from '@holmescorp/card';
import { convertToBoolean } from '@holmescorp/common';
import { createNlsMiddleware } from '@holmescorp/lcc-state';
import css from '../../css/nav-card.m.css';
const ditabookNls = createNlsMiddleware('ditabook');
const quizNls = createNlsMiddleware('quiz');
const factory = create({
    theme,
    ditabookNls,
    quizNls
}).properties();
export const ViewAssessmentsCard = factory(({ id, properties, middleware: { theme, ditabookNls, quizNls } }) => {
    const themeCss = theme.classes(css);
    const { xqa, setTitle, switchView } = properties();
    const { messages: { continueAssessments = '(ditabook) continueAssessments', assess_title = '(ditabook) assess_title', is_demo = 'false' } } = ditabookNls();
    const { messages: { continue: kontinue = '(quiz) continue' } } = quizNls();
    const isDemo = convertToBoolean(is_demo);
    return v('div', { id, classes: [theme.variant()] }, [
        w(Card, { xqa }, [
            {
                content: v('div', { classes: [themeCss.assess_card, 'assess_card'] }, [
                    v('div', { classes: [themeCss.title] }, [continueAssessments]),
                    v('div', { classes: [themeCss.actions] }, [
                        w(Button, {
                            onClick: () => {
                                setTitle && setTitle(assess_title);
                                switchView('assess');
                            },
                            disabled: isDemo,
                            iconPosition: 'after',
                            aria: { label: `${kontinue} and ${continueAssessments}` }
                        }, [
                            {
                                icon: isDemo
                                    ? v('span', { styles: { paddingLeft: '5px' } }, [w(Icon, { faname: 'lock' })])
                                    : undefined,
                                label: kontinue
                            }
                        ])
                    ])
                ])
            }
        ])
    ]);
});
export default ViewAssessmentsCard;
